<template>
    <footer class="bg-blue_primary text-white py-6">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col items-end">
          
          <div class="text-sm text-gray-300 text-right">
            <span>Issues while using the tool? Please contact: </span>
            <a
              href="mailto:support@teopm.com"
              class="text-gray-300 underline hover:text-gray-200"
            >
              support@teopm.com
            </a>
          </div>
        </div>
  
      
        <div class="mt-4 text-right text-gray-400 text-xs">
          © 2024. All rights reserved.
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {};
  </script>
  